/* eslint-disable no-undef */
import React from "react";
import "./scss/app.scss";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Login } from "./login/login.jsx";
function App() {
  return (
    <div className="layout">
      <Router>
          <Route exact path={IBMRR_SD + "biLogin.do"}>
            <Login />
          </Route>
      </Router>
    </div>
  );
}

export default App;
